<template>
  <div class="documentacao-container">
    <h2 class="documentacao-title">Documentação do Imóvel</h2>
      <v-row dense>
        <v-col
          v-for="(documento, index) in documentos"
          :key="index"
          cols="12"
          md="6"
          lg="3"
          class="documento-item"
          :class="{ 'documento-desativado': !documento.isRegularized }"
        >
          <v-icon
            :size="32"
            :color="documento.isRegularized ? 'success' : 'grey'"
            class="documento-icon"
          >
            {{ documento.icone }}
          </v-icon>
          <span
            :class="{ 'texto-desativado': !documento.isRegularized }"
            class="documento-texto"
          >
            {{ documento.texto }}
          </span>
        </v-col>
      </v-row>
  </div>
</template>

<script>
export default {
  name: "DocumentacaoImovelComponent",
  props: {
    documentos: {
      type: Array,
      required: true,
      default: () => [
        { icone: "mdi-file-document-outline", texto: "Escritura Definitiva", isRegularized: true },
        { icone: "mdi-bank", texto: "Permite Financiamento", isRegularized: true },
      ],
    },
  },
};
</script>

<style scoped>
.documentacao-container {
  width: 100%;
  margin: 2rem auto;
  padding: 0;
  max-width: 1400px;
}

.documentacao-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: var(--v-primary-base);
  padding: 0 1rem;
  text-align: left;
  letter-spacing: -0.5px;
  line-height: 1.2;
}

.documento-item {
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
  padding: 0 1rem;
  justify-content: flex-start;
  transition: opacity 0.3s ease;
}

.documento-icon {
  margin-right: 1.25rem;
}

.documento-texto {
  font-size: 1.1rem;
  color: var(--v-secondary-base);
  font-weight: 500;
  text-align: left;
  letter-spacing: 0.25px;
  line-height: 1.5;
}

.documento-desativado {
  opacity: 0.5;
}

.texto-desativado {
  color: var(--v-grey-base);
}

@media (max-width: 600px) {
  .documentacao-container {
    margin: 1.5rem auto;
  }

  .documentacao-title {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .documento-texto {
    font-size: 1rem;
  }
}
</style>